import React from "react";
import { Box, Card, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Helmet } from "react-helmet-async";

function Restrict() {
  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2 }}>
      <Helmet>
        <title>Restricted | Risk Manager</title>
      </Helmet>
      <Card sx={{ maxWidth: 560, p: { xs: 3, sm: 4 } }}>
        <Box sx={{ width: 48, height: 48, borderRadius: 2, display: "grid", placeItems: "center", bgcolor: "#FEE2E2", color: "error.main", mb: 2 }}>
          <LockOutlinedIcon />
        </Box>
        <Typography variant="h5">You don't have access to Risk Manager</Typography>
        <Typography color="text.secondary" sx={{ mt: 1.5 }}>
          Your account is restricted for this app. If you think this is a mistake, contact your system
          administrator or IT department.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2.5, pt: 2.5, borderTop: 1, borderColor: "divider" }}>
          This system is for authorized users only. Use of it may be monitored, recorded and audited.
          Unauthorized access or use is prohibited and may lead to criminal and civil penalties.
        </Typography>
      </Card>
    </Box>
  );
}

export default Restrict;
